import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from './contexts/AuthContext';
import { initializeMatomo, rememberSeoEntryPage, trackPageView } from './utils/matomo';
import { LocaleLayout } from './contexts/LocaleContext';
import { buildSharedRouteElements } from './routes/sharedAppRoutes';

function AppContent() {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const initMatomo = () => initializeMatomo();

    if (typeof window.requestIdleCallback === 'function') {
      const idleId = window.requestIdleCallback(initMatomo, { timeout: 3000 });
      return () => window.cancelIdleCallback(idleId);
    }

    const timer = setTimeout(initMatomo, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    rememberSeoEntryPage(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (location.hash) {
      return;
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const timer = setTimeout(() => {
      trackPageView();
    }, 100);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, viewport-fit=cover, shrink-to-fit=no"
        />
      </Helmet>
      <Routes>
      <Route path="/en" element={<LocaleLayout locale="en" />}>
        {buildSharedRouteElements({ isAuthenticated, user, locale: 'en' })}
      </Route>
      <Route element={<LocaleLayout locale="fr" />}>
        {buildSharedRouteElements({ isAuthenticated, user, locale: 'fr' })}
      </Route>
    </Routes>
    </>
  );
}

function App() {
  return <AppContent />;
}

export default App;
